/**
 * Cases API
 * CRUD operations for case management
 */

import apiClient from '@/lib/api-client'
import type {
  Case,
  CaseUpdate,
  CaseFilters,
  CasePaginatedResponse,
  Lawyer,
} from '@/types/case'
import type { PaginationParams } from '@/types/common'

export const casesApi = {
  /**
   * Get all lawyers for filter dropdown
   */
  async getLawyers(officeId?: number): Promise<Lawyer[]> {
    const params: Record<string, any> = {}
    if (officeId !== undefined) params.office_id = officeId
    const response = await apiClient.get<Lawyer[]>('/cases/lawyers', { params })
    return response.data
  },

  /**
   * Get paginated list of cases with filters
   */
  async getAll(
    filters?: CaseFilters,
    pagination?: PaginationParams
  ): Promise<CasePaginatedResponse> {
    const params = { ...filters, ...pagination }
    const response = await apiClient.get<CasePaginatedResponse>('/cases', {
      params,
    })
    return response.data
  },

  /**
   * Get case by ID
   */
  async getById(id: string): Promise<Case> {
    const response = await apiClient.get<Case>(`/cases/${id}`)
    return response.data
  },

  /**
   * Update existing case
   */
  async update(id: string, data: CaseUpdate): Promise<Case> {
    const response = await apiClient.put<Case>(`/cases/${id}`, data)
    return response.data
  },
}

export default casesApi
